import { useCallback, useEffect, useState } from "react";
import BonusSelect from "../../component/BonusSelect";
import Layout from "../Layout";
import { useNavigate, useParams } from "react-router-dom";
import CustomCalendar from "./CustomCalendar";
import moment from "moment";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { debounce, isEmpty, startCase, upperCase } from "lodash";
import { formatWithCommas, toFixedWithoutRounding } from "../../Utils/Toast";
import BettingHistoryTab from "../BettingHistoryTab";
import { MdArrowRight } from "react-icons/md";
const History = () => {
  const [show, setShow] = useState(false);
  const [tab, setTab] = useState("type");
  const [modal, setModal] = useState(false);
  const { type } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loader, setLoader] = useState(false);
  const [filter, setFilter] = useState({
    betType: "betfair",
    status: "completed",
    fromPeriod: moment(new Date()).format("YYYY-MM-DD"),
    toPeriod: moment(new Date()).format("YYYY-MM-DD"),
    page: 1,
    limit: 50,
  });
  let dummy = {
    BetFair: "betfair",
    Bookmaker: "bookmaker",
    Fancy: "fancy",
    SportsBook: "sportBook",
  };
  let obj = {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  };

  const getData = async (obj = filter) => {
    const { status, data } = await apiGet(apiPath.getHistory, {
      betType: obj?.betType,
      status: "completed",
      fromPeriod: moment(obj?.fromPeriod).format("YYYY-MM-DD"),
      toPeriod: moment(obj?.toPeriod).format("YYYY-MM-DD"),
      page: obj?.page || 1,
      limit: obj?.limit,
    });
    if (status == 200) {
      if (data?.success) {
        if (data?.results?.data?.length > 0) {
          setData(data?.results?.data);
          setTotal(
            obj?.tab == "Casino"
              ? calculateTotalsCasino(data?.results?.data)
              : calculateTotals(data?.results?.data),
          );
        } else {
          setData([]);
          setTotal({});
        }
      }
    }
    setLoader(false);
  };
  const getDepositHistory = async (obj = filter) => {
    const { status, data } = await apiGet(apiPath.depositHistory, {
      fromPeriod: moment(obj?.fromPeriod).format("YYYY-MM-DD"),
      toPeriod: moment(obj?.toPeriod).format("YYYY-MM-DD"),
      page: obj?.page,
      limit: obj?.limit,
      status: obj?.type,
    });
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
      }
    }
    setLoader(false);
  };
  const getWithdrawHistory = async (obj = filter) => {
    const { status, data } = await apiGet(apiPath.withDrawHistory, {
      fromPeriod: moment(obj?.fromPeriod).format("YYYY-MM-DD"),
      toPeriod: moment(obj?.toPeriod).format("YYYY-MM-DD"),
      page: obj?.page,
      limit: obj?.limit,
    });
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
      }
    }
    setLoader(false);
  };
  const getAccountHistory = async (obj = filter) => {
    const { status, data } = await apiGet(apiPath.accountStatement, {
      fromPeriod: moment(obj?.fromPeriod).format("YYYY-MM-DD"),
      toPeriod: moment(obj?.toPeriod).format("YYYY-MM-DD"),
      page: obj?.page,
      limit: obj?.limit,
    });
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
      }
    }
    setLoader(false);
  };
  const ShowPrice = (res) => {
    if (isEmpty(res?.fancyName)) {
      if (
        (res?.teamSelectionWin == res?.selectionId && res?.betType == "back") ||
        (res?.teamSelectionWin != res?.selectionId && res?.betType == "lay")
      ) {
        return res?.profitAmount;
      } else {
        return -res?.loseAmount;
      }
    } else {
      if (res?.type == "No") {
        if (res?.decisionRun < res?.betRun) {
          return res?.profitAmount;
        } else {
          return -res?.loseAmount;
        }
      } else {
        if (res?.decisionRun >= res?.betRun) {
          return res?.profitAmount;
        } else {
          return -res?.loseAmount;
        }
      }
    }
  };
  function calculateTotalsCasino(bets) {
    let totalAmount = 0;
    let profitLoss = 0;
    let totalOdds = 0;
    bets.forEach((res) => {
      totalAmount += res.betAmount;
      profitLoss += parseFloat(res.playerPL);
    });

    return {
      totalAmount,
      profitLoss,
      totalOdds,
    };
  }
  function calculateTotals(bets) {
    let totalAmount = 0;
    let profitLoss = 0;
    let totalOdds = 0;
    bets.forEach((res) => {
      totalAmount += res.amount;
      totalOdds += parseFloat(res.bhav || 0); // safely parse bhav as float
      let isFancy = !!res.fancyName; // fancyName presence check

      if (!isFancy) {
        const isBackWin =
          res.teamSelectionWin == res.selectionId && res.betType === "back";
        const isLayWin =
          res.teamSelectionWin != res.selectionId && res.betType === "lay";

        if (isBackWin || isLayWin) {
          profitLoss += res.profitAmount;
        } else {
          profitLoss -= res.loseAmount;
        }
      } else {
        // Fancy logic
        const isNo = res.type === "No";

        if (isNo) {
          if (res.decisionRun < res.betRun) {
            profitLoss += res.profitAmount;
          } else {
            profitLoss -= res.loseAmount;
          }
        } else {
          if (res.decisionRun >= res.betRun) {
            profitLoss += res.profitAmount;
          } else {
            profitLoss -= res.loseAmount;
          }
        }
      }
    });

    return {
      totalAmount,
      profitLoss,
      totalOdds,
    };
  }

  // Debounce wrapper to avoid multiple API calls
  const debouncedFetch = useCallback(
    debounce((obj) => {
      if (type == "betting-history") {
        getData(obj);
      } else if (type == "deposit-history") {
        getDepositHistory(obj);
      } else if (type == "withdrawl-history") {
        getWithdrawHistory(obj);
      } else if (type == "transaction-history") {
        getAccountHistory(obj);
      }
    }, 500), // wait 600ms
    [],
  );

  // Trigger API when filter changes but debounced
  useEffect(() => {
    setLoader(true);
    debouncedFetch(filter);
  }, [filter, type]);
  return (
    <Layout>
      <div style={{ overflow: "hidden" }}>
        <div className="row hidden-md-and-up" style={{ height: "75px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "#ffce01",
              justifyContent: "center",
            }}
            className="mobile-header text-center white--text col col-12"
          >
            History
          </div>
        </div>
        <div
          className="mobile-menu-card v-card v-sheet theme--light"
          style={{ "border-radius": "unset", background: "white" }}
        >
          <div className="row no-gutters justify-space-around">
            <div style={{ height: "100%" }} className="col col-12">
              <div className="mobile-menu-card-wrapper v-card v-sheet theme--light">
                <button
                  onClick={() => {
                    setShow(true);
                    setTab("type");
                  }}
                  type="button"
                  className="mobile-category-menuBtn v-btn v-btn--block v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="v-btn__content">
                    {object[type]}
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate v-icon--right mdi mdi-menu-down theme--light"
                      style={{ "font-size": "36px" }}
                    />
                  </span>
                </button>
              </div>{" "}
              {type == "betting-history" && (
                <div className="mobile-menu-card-wrapper v-card v-sheet theme--light">
                  <button
                    onClick={() => {
                      setShow(true);
                      setTab("betType");
                    }}
                    type="button"
                    className="mobile-category-menuBtn v-btn v-btn--block v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span className="v-btn__content">
                      {startCase(filter?.betType)}
                      <i
                        aria-hidden="true"
                        className="v-icon notranslate v-icon--right mdi mdi-menu-down theme--light"
                        style={{ "font-size": "36px" }}
                      />
                    </span>
                  </button>
                </div>
              )}
              <div className="pt-2 pb-2 px-4 col col-12">
                <div
                  onClick={() => setModal(true)}
                  style={{
                    boxShadow:
                      "0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)",
                  }}
                  className="v-input date-search-mobile mb-3 elevation-0 text-center v-input--hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined"
                >
                  <div style={{ color: "white" }} className="v-input__control">
                    <div className="v-input__slot">
                      <fieldset aria-hidden="true">
                        <legend style={{ width: "0px" }}>
                          <span className="notranslate">​</span>
                        </legend>
                      </fieldset>
                      <div className="v-text-field__slot">
                        <input
                          style={{ color: "white" }}
                          readOnly
                          value={`${filter?.fromPeriod} - ${filter?.toPeriod}`}
                          id="input-268"
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ height: "100%" }} className="fullHeight col col-12">
                <div
                  style={{ height: "100%" }}
                  className="v-data-table elevation-0 fullHeight theme--light"
                >
                  <div
                    style={{ height: "100%" }}
                    className="v-data-table__wrapper"
                  >
                    <table style={{ height: "100%" }}>
                      <thead>
                        {type == "betting-history" && (
                          <tr>
                            <th className="align-L" id="Matched_market">
                              Bet ID
                            </th>
                            <th id="Matched_selection">PL ID</th>
                            <th id="Matched_type">Market</th>
                            <th id="Matched_betId" width="9%">
                              Selection
                            </th>
                            <th id="Matched_betPlaced" width="8%">
                              Type
                            </th>
                            <th id="Matched_oddsReq" width="8%">
                              Bet placed
                            </th>
                            <th id="Matched_matched" width="9%">
                              Odds req.
                            </th>
                            <th id="Matched_avgOdds" width="10%">
                              Stake
                            </th>

                            <th id="Matched_dateMatched" width="10%">
                              Profit/Loss
                            </th>
                          </tr>
                        )}
                        {type == "transaction-history" && (
                          <tr>
                            <th scope="col">Date/Time</th>
                            <th scope="col">Deposit</th>
                            <th scope="col">WithDraw</th>
                            <th scope="col">Balance</th>
                            <th scope="col">Remark</th>
                            <th scope="col">From/To</th>
                          </tr>
                        )}
                        {["withdrawl-history", "deposit-history"].includes(
                          type,
                        ) && (
                          <tr>
                            {(type == "withdrawl-history"
                              ? WithdrawHeader
                              : DepositHeader
                            )?.map((res) => {
                              return <th scope="col">{res}</th>;
                            })}
                          </tr>
                        )}
                      </thead>
                      {type == "betting-history" && (
                        <BettingHistoryTab
                          data={data}
                          key={filter?.betType}
                          betCheckObj={betCheckObj}
                        />
                      )}
                      {["withdrawl-history", "deposit-history"].includes(
                        type,
                      ) && ""}
                      {type == "transaction-history" ? (
                        data.data?.length > 0 ? (
                          <tbody id="Matched_Content">
                            {data.data &&
                              data.data.map((item, key) => (
                                <tr>
                                  <td>
                                    {moment(item?.createdAt).format(
                                      "YYYY-MM-DD hh:mm:ss",
                                    )}
                                  </td>
                                  <td>
                                    {item?.transactionType === "credit" ? (
                                      <span className="">
                                        {formatWithCommas(item?.amount)}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    {" "}
                                    {item?.transactionType === "debit" ? (
                                      <span className="text-danger">
                                        {"(" +
                                          formatWithCommas(item?.amount) +
                                          ")"}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                  <td>{formatWithCommas(item?.newBalance)}</td>
                                  <td width={"26%"}>{item?.remark || "N/A"}</td>

                                  <td>
                                    {startCase(item?.createdByData?.userType) ||
                                      "N/A"}{" "}
                                    <MdArrowRight
                                      size={20}
                                      style={{ verticalAlign: "middle" }}
                                    />
                                    {item?.userData?.username || "N/A"}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        ) : (
                          <tbody id="Matched_Content">
                            <tr
                              id="noDataTemplate"
                              style={{
                                display: "table-row",
                              }}
                            >
                              <td className="no-data" colSpan="9">
                                <p>You have no bets in this time period.</p>
                              </td>
                            </tr>
                          </tbody>
                        )
                      ) : (
                        ""
                      )}
                      {["withdrawl-history", "deposit-history"].includes(
                        type,
                      ) && (
                        <tbody>
                          {" "}
                          {data?.length > 0 ? (
                            data?.map((res) => {
                              return type == "deposit-history" ? (
                                <tr className="table-tr">
                                  <td
                                    style={{ width: "13%" }}
                                    className="table-td"
                                  >
                                    {startCase(res?.bank_name) ||
                                      startCase(res.bank)}
                                  </td>{" "}
                                  <td
                                    style={{ width: "13%" }}
                                    className="table-td"
                                  >
                                    {moment(res?.createdAt).format(
                                      "YYYY-MM-DD hh:mm:ss",
                                    )}
                                  </td>{" "}
                                  <td
                                    style={{ width: "13%" }}
                                    className="table-td"
                                  >
                                    {formatWithCommas(res?.amount)}
                                  </td>{" "}
                                  <td
                                    style={{ width: "13%" }}
                                    className="table-td"
                                  >
                                    {formatWithCommas(
                                      res?.amount +
                                        (res?.bonus > 0 ? res?.bonus : 0),
                                    )}
                                  </td>{" "}
                                  <td
                                    style={{ width: "13%" }}
                                    className="table-td"
                                  >
                                    {res?.transferedProcess == "process"
                                      ? "Processing"
                                      : res?.status == "completed"
                                        ? "Approve"
                                        : res?.transferedProcess == "requested"
                                          ? "Requested"
                                          : "Decline"}
                                  </td>{" "}
                                  <td
                                    style={{ width: "13%" }}
                                    className="table-td"
                                  >
                                    {res?.promotionCode || "-"}
                                  </td>{" "}
                                  <td
                                    style={{ width: "13%" }}
                                    className="table-td"
                                  >
                                    {res?.remark || "-"}
                                  </td>{" "}
                                </tr>
                              ) : type == "withdrawl-history" ? (
                                <tr className="table-tr">
                                  <td
                                    style={{ width: "13%" }}
                                    className="table-td"
                                  >
                                    {startCase(res?.bank_name) ||
                                      startCase(res.bank)}
                                  </td>{" "}
                                  <td
                                    style={{ width: "13%" }}
                                    className="table-td"
                                  >
                                    {moment(res?.createdAt).format(
                                      "YYYY-MM-DD hh:mm:ss",
                                    )}
                                  </td>{" "}
                                  <td
                                    style={{ width: "13%" }}
                                    className="table-td"
                                  >
                                    {formatWithCommas(res?.amount)}
                                  </td>{" "}
                                  <td
                                    style={{ width: "13%" }}
                                    className="table-td"
                                  >
                                    {formatWithCommas(
                                      res?.amount +
                                        (res?.bonus > 0 ? res?.bonus : 0),
                                    )}
                                  </td>{" "}
                                  <td
                                    style={{ width: "13%" }}
                                    className="table-td"
                                  >
                                    {res?.transferedProcess == "process"
                                      ? "Processing"
                                      : res?.status == "completed"
                                        ? "Approve"
                                        : res?.transferedProcess == "requested"
                                          ? "Requested"
                                          : "Decline"}
                                  </td>{" "}
                                  <td
                                    style={{ width: "13%" }}
                                    className="table-td"
                                  >
                                    {res?.remark || "-"}
                                  </td>{" "}
                                </tr>
                              ) : (
                                ""
                              );
                            })
                          ) : (
                            <tr
                              id="noDataTemplate"
                              style={{
                                display: "table-row",
                              }}
                            >
                              <td className="no-data" colSpan="9">
                                <p>You have no bets in this time period.</p>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {show && (
        <BonusSelect
          options={
            tab == "type"
              ? option
              : [
                  {
                    title: "betfair",
                    key: "betfair",
                  },
                  {
                    title: "bookmaker",
                    key: "bookmaker",
                  },
                  {
                    title: "fancy",
                    key: "fancy",
                  },
                  {
                    title: "sportBook",
                    key: "sportBook",
                  },
                  {
                    title: "casino",
                    key: "casino",
                  },
                ]
          }
          value={
            tab == "type"
              ? option?.find((res) => {
                  return res?.key == type;
                })?.title
              : filter?.betType
          }
          onChange={(e) => {
            if (tab == "type") {
              navigate(`/history/${e?.key}`);
            } else {
              setFilter((prev) => {
                return { ...prev, betType: e?.key };
              });
            }
          }}
          show={show}
          setShow={setShow}
        />
      )}
      {modal && (
        <CustomCalendar
          setShow={setModal}
          value={filter}
          onChange={(e) => {
            setFilter((prev) => {
              return {
                ...prev,
                fromPeriod: moment(e?.startDate).format("YYYY-MM-DD"),
                toPeriod: moment(e?.endDate).format("YYYY-MM-DD"),
              };
            });
          }}
        />
      )}
    </Layout>
  );
};

export default History;
let option = [
  {
    title: "Bet History",
    key: "betting-history",
  },
  {
    title: "Account History",
    key: "transaction-history",
  },
  {
    title: "Deposit History",
    key: "deposit-history",
  },
  {
    title: "Withdrawl History",
    key: "withdrawl-history",
  },
];

let object = {
  "betting-history": "Bet History",
  "transaction-history": "Account History",
  "deposit-history": "Deposit History",
  "withdrawl-history": "Withdrawl History",
};
let betCheckObj = {
  4: "Cricket",
  2: "Tennis",
  1: "Soccer",
  3: "Casino",
};

let WithdrawHeader = [
  "Bank",
  "Transaction Time",
  "Requested amount",
  "Received amount",
  "Status",
  "Remark",
];
let DepositHeader = [
  "Bank",
  "Transaction Time",
  "Requested amount",
  "Received amount",
  "Status",
  "Promotions",
  "Remark",
];
